import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const ControlContainer = styled(Flex)
    .withConfig({ displayName: 'ControlContainer' })
    .attrs({
        spacing: 2,
        direction: 'row',
        alignItems: 'center',
        width: { xs: 'auto' },
        p: { xs: 1, sm: 1.5 },
    })`
    text-decoration: none;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 0ms;
    transition-property: color, transform;
    color: var(--color-secondary);
    cursor: pointer;

    &:hover,
    &:focus,
    &:active,
    &.active {
        color: var(--color-primary);
    }
`;

export const MultiProfileContainer = styled(Flex)
    .withConfig({ displayName: 'MultiProfileContainer' })
    .attrs({
        width: 52,
        height: 27,
        p: 0.2,
        alignItems: 'center',
        direction: 'row',
    })`
    border-radius: 100px;
    background-color: var(--control-secondary-background);
    cursor: pointer;
`;
